export var ORIENTATIONS = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical'
});